import React from 'react';

export class InfoDescription extends React.Component {
  render(){
      return(
        <p className="px-lg-4">
          {this.props.children}
        </p>
      );
  }
}